import * as datasouce from "../common_metadata/datasource.js"
import { Innosoft_InnoBI_Controllers_DynamicApiController as DynamicApiController } from "../generated_api/generated_api.js"

interface IComponentDataFetchState {
    requiredDataSources: datasouce.Datasource[];
    dataFetched: boolean;
    callback: any;
    additionalParams: any
}

interface IServiceRequest {
    Parameters: {};
    Datasource: datasouce.Datasource;
}

export interface ParamsToStore {
    StorageKey: string;
    ParamsToStore: string
}

interface AllServiceRequests {
    services: { [key: string]: IServiceRequest; };
    parameterToStore: ParamsToStore;
}


export class StatisticDataStore {
    private registeredComponents: { [key: string]: IComponentDataFetchState; } = {};
    private openRequestsCount: number = 0;
    private dataCache: any;
    public onBeginDataLoad: any;
    public onFinishedDataLoad: any;
    private cancel: boolean;

    constructor(onBeginDataLoad: any, onFinishedDataLoad: any) {
        this.onBeginDataLoad = onBeginDataLoad;
        this.onFinishedDataLoad = onFinishedDataLoad;
    }

    registerService(componentId: string, services: string[], callback, additionalParams: any, requiredDatasources: datasouce.Datasource[]) {
        let datasources = requiredDatasources;

        //HACK: URLs werden in Datasourcen umgewandelt. In Zukunft darf nur Datasource übergeben werden.
        if (services && (!datasources || !datasources[0])) {
            datasources = services.map((serviceUrl) => {

                const datasource = new datasouce.UrlDataSource();
                datasource.dataUrl = serviceUrl;
                return datasource;
            });
        }
        if (datasources && datasources.length > 0) {
            this.registeredComponents[componentId] = {
                requiredDataSources: datasources.filter((v) => v != null),
                dataFetched: false,
                callback: callback,
                additionalParams: additionalParams
            };
        }
    }

    unregisterServices(componentId: string) {
        delete this.registeredComponents[componentId];
    }

    loadMissingData(parameters: any) {
        let servicesToFetch: { [key: string]: IServiceRequest; } = {};

        for (let componentId in this.registeredComponents) {
            if (this.registeredComponents[componentId].dataFetched == false) {
                this.registeredComponents[componentId].dataFetched = true;
                for (let service of this.registeredComponents[componentId].requiredDataSources) {
                    const additionalParams = this.registeredComponents[componentId].additionalParams;
                    const cachingKey = service.getDataSourceIdentifier() + (additionalParams ? componentId : "");
                    if (!cachingKey) {
                        break;
                    }
                    //Nur laden  wenn nicht im Cache
                    if (!this.dataCache || !this.dataCache[cachingKey]) {

                        let newParams = $.extend({}, parameters);
                        if (additionalParams) {
                            newParams = $.extend(newParams, additionalParams);
                        }
                        servicesToFetch[cachingKey] = { Parameters: newParams, Datasource: service };
                    }
                    else {
                        this.registeredComponents[componentId].callback && setTimeout(() => this.registeredComponents[componentId].callback(this.dataCache));
                    }
                }
            }
        }
        this.requestData(servicesToFetch);
    }

    loadChildData(parameters: any, childComponents: any) {
        let servicesToFetch: { [key: string]: IServiceRequest; } = {};

        for (let componentId in this.registeredComponents) {
            if (childComponents[componentId]) {
                this.registeredComponents[componentId].dataFetched = true;
                for (let service of this.registeredComponents[componentId].requiredDataSources) {
                    let newParams = $.extend({}, parameters);
                    newParams = $.extend(newParams, childComponents[componentId].params);
                    servicesToFetch[service.getDataSourceIdentifier() + componentId] = { Parameters: newParams, Datasource: service };
                }
            }
        }
        this.requestData(servicesToFetch);
    }

    private lastRequestPayload: { [key: string]: IServiceRequest };
    private requestData(servicesToFetch: { [key: string]: IServiceRequest; }, clearCache: boolean = false, parameterToStore?: ParamsToStore) {
        const currentRequestPayload = servicesToFetch;
        this.lastRequestPayload = servicesToFetch;

        if (Object.keys(servicesToFetch).length === 0) {
            return;
        }

        this.openRequestsCount++;

        if (this.openRequestsCount == 1 && this.onBeginDataLoad) {
            this.onBeginDataLoad();
        }

        new DynamicApiController().GetDataBatched({ Services: servicesToFetch, Parameters: parameterToStore }, (data) => {
            this.openRequestsCount--;
            if (currentRequestPayload == this.lastRequestPayload) {
                if (!this.dataCache || clearCache) {
                    this.dataCache = {};
                }

                $.extend(this.dataCache, data);

                if (data != null && !this.cancel) {
                    for (let componentId in this.registeredComponents) {
                        this.registeredComponents[componentId].callback && this.registeredComponents[componentId].callback(data);
                    }
                }
            }
            if (this.openRequestsCount == 0 && this.onFinishedDataLoad) {
                this.onFinishedDataLoad();
            }
        },
            () => {
                this.openRequestsCount--;
                if (this.openRequestsCount == 0 && this.onFinishedDataLoad && !this.cancel) {
                    this.onFinishedDataLoad();
                }
            });
    }

    reloadAllData(parameters: {}, parameterToStore?: ParamsToStore) {
        let servicesToFetch: { [key: string]: IServiceRequest; } = {};

        for (let componentId in this.registeredComponents) {
            this.registeredComponents[componentId].dataFetched = true;
            for (let service of this.registeredComponents[componentId].requiredDataSources) {
                servicesToFetch[service.getDataSourceIdentifier()] = { Parameters: parameters, Datasource: service };
            }
        }

        this.requestData(servicesToFetch, true, parameterToStore);
    }

    cancelRequests = () => {
        this.cancel = true;
    }
}